import { com } from '@glovo/customer-analytics'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'
import type { PickAnalyticsEventAttributes } from '@/tools/analytics/types'
import PaymentMethod = com.glovoapp.analytics.events.PaymentMethod

export const PaymentProcessingStarted = (
  attributes: PickAnalyticsEventAttributes<'PaymentProcessingStarted'>
) => {
  const { PaymentProcessingStarted, PaymentChangeScreenOrigin } = analyticsEvents
  return new PaymentProcessingStarted(PaymentChangeScreenOrigin[attributes.origin])
}

export const PaymentProcessingFinished = (
  attributes: PickAnalyticsEventAttributes<'PaymentProcessingFinished'>
) => {
  const { PaymentProcessingFinished, PaymentChangeScreenOrigin, PaymentProcessingStatus } =
    analyticsEvents
  return new PaymentProcessingFinished(
    PaymentChangeScreenOrigin[attributes.origin],
    PaymentProcessingStatus[attributes.status]
  )
}

export const PaymentProcessingCanceled = (
  attributes: PickAnalyticsEventAttributes<'PaymentProcessingCanceled'>
) => {
  const { PaymentProcessingCanceled, PaymentChangeScreenOrigin } = analyticsEvents
  return new PaymentProcessingCanceled(PaymentChangeScreenOrigin[attributes.origin])
}

export const PaymentChange = () => {
  const { PaymentChange } = analyticsEvents
  return new PaymentChange()
}

export const PaymentInfo = (attributes: PickAnalyticsEventAttributes<'PaymentInfo'>) => {
  const { PaymentInfo } = analyticsEvents
  return new PaymentInfo(attributes.origin, attributes.provider)
}

export const PaymentInfoEntered = (
  attributes: PickAnalyticsEventAttributes<'PaymentInfoEntered'>
) => {
  const { PaymentInfoEntered } = analyticsEvents
  return new PaymentInfoEntered(
    attributes.origin,
    attributes.cardId,
    attributes.nicknameAvailable,
    attributes.provider
  )
}

export const PaymentInfoFailed = (
  attributes: PickAnalyticsEventAttributes<'PaymentInfoFailed'>
) => {
  const { PaymentInfoFailed } = analyticsEvents
  return new PaymentInfoFailed(
    attributes.origin,
    attributes.errorCode,
    attributes.errorMessage,
    attributes.provider
  )
}

export const PaymentMethodSelector = (
  attributes: PickAnalyticsEventAttributes<'PaymentMethodSelector'>
) => {
  const { PaymentMethodSelector, PaymentChangeScreenOrigin } = analyticsEvents
  return new PaymentMethodSelector(PaymentChangeScreenOrigin[attributes.origin])
}

export const PaymentMethodSelectorUpdated = (
  attributes: PickAnalyticsEventAttributes<'PaymentMethodSelectorUpdated'>
) => {
  const {
    PaymentMethodSelectorUpdated,
    PaymentChangeScreenOrigin,
    PaymentMethod,
    AlternativePlatformNameType,
  } = analyticsEvents
  let paymentMethod
  if (PaymentMethod[attributes.newPaymentMethod] === PaymentMethod.CreditCard) {
    paymentMethod = new PaymentMethod.CreditCard(
      attributes.metadata?.provider,
      attributes.metadata?.id,
      attributes.metadata?.nickNameAvailable
    )
  } else if (
    PaymentMethod[attributes.newPaymentMethod] === PaymentMethod.Alternative &&
    attributes.metadata?.platformName
  ) {
    paymentMethod = new PaymentMethod.Alternative(
      AlternativePlatformNameType[attributes.metadata.platformName]
    )
  } else {
    paymentMethod = PaymentMethod[attributes.newPaymentMethod]
  }
  return new PaymentMethodSelectorUpdated(
    PaymentChangeScreenOrigin[attributes.origin],
    paymentMethod as PaymentMethod,
    attributes.prevPaymentMethod
  )
}

export const ThreeDS2AuthenticationFailed = (
  attributes: PickAnalyticsEventAttributes<'ThreeDS2AuthenticationFailed'>
) => {
  const { ThreeDS2AuthenticationFailed } = analyticsEvents
  return new ThreeDS2AuthenticationFailed(attributes.errorMessage, attributes.invoiceId)
}
